import globals from "@/utils/globals";

export const initDataLayer = () => {
  if (typeof window.dataLayer === "undefined") {
    window.dataLayer = [];
  }

  if (typeof window.sentDataLayerEvents === "undefined") {
    window.sentDataLayerEvents = [];
  }
};

export const loadScript = () => {
  if (globals.gtmId && globals.clientPlatform === "web") {
    /* eslint-disable */
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      '//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer', globals.gtmId);
    /* eslint-enable */
  }
};

export const push = event => {
  window.dataLayer.push(event);
};

export const sendEvent = event => {
  const eventName = event.event;

  window.sentDataLayerEvents.push(eventName);

  push(event);
};

export const sendUniqEvent = event => {
  const eventName = event.event;

  if (window.sentDataLayerEvents.indexOf(eventName) === -1) {
    sendEvent(event);
  }
};
